"use strict";
/**
 * Created by SH: 02/20/2020
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReelEngineController = exports.ReelState = void 0;
const gsap_1 = require("gsap");
const ReelEngineEvent_1 = require("./event/ReelEngineEvent");
const ReelEngine_1 = require("./engine/ReelEngine");
const ReelEngineView_1 = require("./ReelEngineView");
const ReelSpriteSymbolArea_1 = require("./symbol/ReelSpriteSymbolArea");
const StateHandler_1 = require("../../utils/StateHandler");
const GameSetting_1 = require("../../setting/GameSetting");
const ReelSymbolName_js_1 = require("../../reelsymbol/ReelSymbolName.js");
const Logger_1 = require("@nolimitcity/slot-launcher/bin/utils/Logger");
const MathHelper_1 = require("../../utils/MathHelper");
const Helper_1 = require("../../utils/Helper");
const EventHandler_1 = require("../../event/EventHandler");
const GameEvent_1 = require("../../event/GameEvent");
const GameConfig_1 = require("../../gameconfig/GameConfig");
class ReelState extends StateHandler_1.StateHandler {
    get isSpinning() {
        return this.equal(ReelState.STEP);
    }
    ;
    get isStarting() {
        return this.equal(ReelState.START);
    }
    ;
    get isIdle() {
        return this.equal(ReelState.IDLE);
    }
    ;
    get isInactive() {
        return this.equal(ReelState.INACTIVE);
    }
    ;
    get isNudging() {
        return this.equal(ReelState.NUDGE);
    }
    ;
    get willUpdateStep() {
        return this.equal(ReelState.STEP, true);
    }
    ;
    get willStop() {
        return this.equal(ReelState.STOP, true) || this.equal(ReelState.QUICK_STOP, true) || this.equal(ReelState.FAST_STOP, true);
    }
    ;
    get isStopping() {
        return this.equal(ReelState.STOP) || this.equal(ReelState.QUICK_STOP) || this.equal(ReelState.FAST_STOP);
    }
    ;
}
//* Basic Behaviours *//
ReelState.START = "start";
ReelState.STEP = "step";
ReelState.STOP = "stop";
ReelState.FAST_STOP = "fast_stop";
ReelState.QUICK_STOP = "quick_stop";
ReelState.IDLE = "idle";
ReelState.INACTIVE = "inactive";
//*  Created Behaviours *//
ReelState.REVERSE = "reverse";
ReelState.NUDGE = "nudge";
// * To be created... * //
ReelState.EXPAND_SYM = "expand_symbol";
ReelState.STOP_TEASER = "stop_teaser";
ReelState.START_TEASER = "start_teaser";
exports.ReelState = ReelState;
class ReelEngineController extends ReelEngineView_1.ReelEngineView {
    constructor() {
        super(...arguments);
        this._reelState = new ReelState(ReelState.INACTIVE);
        this._activeReel = true;
        this._nextResultActive = true;
    }
    get Engine() {
        return this._engine;
    }
    ;
    get state() {
        return this._reelState;
    }
    ;
    get isActive() {
        return this._activeReel && this.visible;
    }
    ;
    get statePosOffset() {
        return this.state.isIdle ? 0 : this.Engine.reverse ? 1 : -1;
    }
    set isActive(value) {
        this._activeReel = value;
    }
    ;
    get isFast() {
        return this.isQuickStop || GameSetting_1.GameSetting.isFastSpin || this.state.equal(ReelState.FAST_STOP);
    }
    ;
    get windowTopSymbol() {
        return this.AllSymbols[this.Engine.reverse ? this.overflowTail : this.overflowDirection];
    }
    get windowBottSymbol() {
        return this.AllSymbols[(this.AllSymbols.length - 1) - (this.Engine.reverse ? this.overflowDirection : this.overflowTail)];
    }
    get overflowDirection() {
        return (this.Engine.reverse ? this.engineConfig.OVERFLOW_BOTT : this.engineConfig.OVERFLOW_TOP);
    }
    get overflowTail() {
        return (this.Engine.reverse ? this.engineConfig.OVERFLOW_TOP : this.engineConfig.OVERFLOW_BOTT);
    }
    get totalOverflow() {
        return this.engineConfig.OVERFLOW_TOP + this.engineConfig.OVERFLOW_BOTT;
    }
    getStartDelay() {
        if (this.isQuickStop)
            return this.engineConfig.DELAY.QUICK_START;
        else if (GameSetting_1.GameSetting.isFastSpin)
            return this.engineConfig.DELAY.FAST_START;
        return this.engineConfig.DELAY.START;
    }
    getStopDelay() {
        if (this.isQuickStop)
            return this.engineConfig.DELAY.QUICK_STOP;
        else if (GameSetting_1.GameSetting.isFastSpin)
            return this.engineConfig.DELAY.FAST_STOP;
        return this.engineConfig.DELAY.STOP;
    }
    getStartDuration() {
        if (this.isQuickStop)
            return this.engineConfig.DURATION.QUICK_START;
        else if (GameSetting_1.GameSetting.isFastSpin)
            return this.engineConfig.DURATION.FAST_START;
        return this.engineConfig.DURATION.START;
    }
    getStopDuration() {
        if (this.isQuickStop)
            return this.engineConfig.DURATION.QUICK_STOP;
        else if (GameSetting_1.GameSetting.isFastSpin)
            return this.engineConfig.DURATION.FAST_STOP;
        return this.engineConfig.DURATION.STOP;
    }
    getStartEase() {
        if (GameSetting_1.GameSetting.isFastSpin || this.isQuickStop)
            return this.engineConfig.EASING.QUICK_START;
        return this.engineConfig.EASING.START;
    }
    getStopEase() {
        if (GameSetting_1.GameSetting.isFastSpin || this.isQuickStop)
            return this.engineConfig.EASING.QUICK_STOP;
        return this.engineConfig.EASING.STOP;
    }
    get stepPosOffset() {
        return this.state.isIdle ? 0 : this.Engine.reverse ? 1 : -1;
    }
    dataParsed(data) {
        this._stopReelSet = Array.from(data.reels[this.reelID]);
        this._quickStopReelSet = this.defineQuickReel(data);
        this._nextReelSetName = data.nextReelSetName;
        this._stickies = this.getStickyGameData(data);
        this._nextResultActive = this.getActiveReels(data);
    }
    ;
    defineQuickReel(data) { return Array.from(data.reels[this.reelID]); }
    getActiveReels(data) { return true; }
    getStickyGameData(data) { return []; }
    createReelEngine() {
        this._engine = new ReelEngine_1.ReelEngine(this.engineCallbacks(), this.config.engine_config, this._areaContainer);
    }
    engineCallbacks() {
        return {
            onStartCallBack: () => this.onStarting(),
            onCompletedStepCallback: () => this.onStep(),
            onStopCallback: () => this.onStopStarted(),
            onCompletedStopCallback: () => this.onStopAnimationCompleted(),
            onCompletedStartCallback: () => this.onStartCompleted(),
            onCompletedExpanding: () => this.completedExpanding(),
            onCompletedNudgeCallback: () => this.completedNudge(),
            onBounceStartCallback: () => this.onBounceStarted(),
        };
    }
    initEngine() { this.createReelEngine(); }
    // Create maxAmount of symbols that can be seen&used.
    initReel() {
        this.initEngine();
        this.setCurrentReelSet(this._nextReelSetName);
        this._symbolAmount = this._showAmount = this.engineConfig.WINDOW_AMOUNT;
        let symInitPos = this._stopReelSet.length - this.engineConfig.OVERFLOW_BOTT;
        let possAdded = 0;
        for (var i = -this.overflowDirection; i < this.windowAmount + this.overflowTail; i++) {
            let symType = this._stopReelSet[symInitPos % this._stopReelSet.length];
            if (symType == ReelSymbolName_js_1.ReelSymbolName.EMPTY)
                symType = "L1";
            const symbol = this.createNewSymbol(i, symType);
            if (i == -this.overflowDirection)
                possAdded = (symbol.symbolHeight * i) - Math.abs(i) * this.engineConfig.STEP_DISTANCE_PADDING_Y;
            else
                possAdded += Math.abs(symbol.symbolHeight) + this.engineConfig.STEP_DISTANCE_PADDING_Y;
            symbol.position = new PIXI.Point(0, possAdded);
            this.addSymbol(symbol);
            symInitPos++;
        }
        this.setVisibleForOverflowSymbols(false);
        this._hasInit = true;
    }
    startDelay() { return this.getStartDelay(); }
    createNextAnimation(state, updateState = false) {
        if (this.state.equal(state))
            return this.Engine.nextTimeline ? this.Engine.nextTimeline : this.Engine.activeTimeline;
        switch (state) {
            case ReelState.START:
                this.Engine.Start();
                break;
            case ReelState.STEP:
                this.Engine.Step();
                break;
            case ReelState.STOP:
            case ReelState.FAST_STOP:
            case ReelState.QUICK_STOP:
                this.Engine.Stop(this.isFast);
                break;
            case ReelState.NUDGE:
                this.Engine.Nudge();
                break;
            case ReelState.IDLE:
            case ReelState.INACTIVE:
                this.Engine.Idle();
                break;
            default:
                console.error("Seems like you are using an undefined ReelState.");
                break;
        }
        while (!this.Engine.nextTimeline)
            this.createNextAnimation(state, updateState);
        if (updateState)
            this.state.set(state);
        return this.Engine.nextTimeline;
    }
    createStart(reverse = false) {
        this.Engine.reverse = reverse;
        this.isQuickStop = false;
        if (this.isActive) {
            return this.createNextAnimation(ReelState.START);
        }
        else {
            return this.createNextAnimation(ReelState.INACTIVE, true);
        }
    }
    startReel() {
        if (this.state.isSpinning)
            return;
        if (!this.isActive) {
            if (this.visible) {
                this.Engine.activateNextAnimation();
                this.createNextAnimation(ReelState.IDLE);
            }
            return;
        }
        this.AllSymbols.forEach(sym => { sym.visible = true; });
        this.Engine.activateNextAnimation();
        // Prepare SpinAnimation
        this.createNextAnimation(ReelState.STEP);
    }
    onStarting() {
        this.state.set(ReelState.START);
        this._symbolAmount = this._showAmount;
        for (let index = 0; index < this.AllSymbols.length; index++) {
            this.AllSymbols[index].y = Math.round(this.AllSymbols[index].y);
        }
        for (var i = 0; i < this.AllSymbols.length; i++) {
            this.AllSymbols[i].changeState({
                state: ReelSpriteSymbolArea_1.ReelSymbolStates.SPIN,
                duration: this.getStartDuration(),
                ease: this.getStartEase()
            });
        }
    }
    onStartCompleted() {
        this.onStep();
        this.state.set(ReelState.STEP);
        // Activates SpinAnimation
        this.Engine.activateNextAnimation();
    }
    tryRemoveSymbol(reverse) {
        const symbolToCheck = reverse ? this.topSymbol : this.bottomSymbol;
        return this.checkSymbolBoundries(symbolToCheck, false, reverse);
    }
    getCurrentStatePositionMap(cont, posState) {
        let state = posState ? posState : this.state.state;
        delete this._currentPointMap;
        this._currentPointMap = [];
        switch (state) {
            case ReelState.START:
            case ReelState.IDLE:
            case ReelState.NUDGE:
            case ReelState.EXPAND_SYM:
            case ReelState.INACTIVE:
                const offsetPaddingY = this.engineConfig.STEP_DISTANCE_PADDING_Y * 0.5;
                for (let row = 0; row < this.AllSymbols.length; row++) {
                    for (let hitPos = 0; hitPos < this.AllSymbols[row].hitPos.length; hitPos++) {
                        this._currentPointMap.push(MathHelper_1.MathHelper.pointAdd(Helper_1.Helper.copyLocalPosition(cont, this.AllSymbols[row]), new PIXI.Point(0, offsetPaddingY)));
                    }
                }
                return this._currentPointMap;
            case ReelState.STEP:
            case ReelState.STOP:
            case ReelState.FAST_STOP:
            case ReelState.QUICK_STOP:
                for (var row = -this.overflowDirection; row < this.windowAmount + this.overflowTail; row++) {
                    const tempSp = new PIXI.Sprite();
                    tempSp.position = new PIXI.Point(0, (Math.abs(this.Engine.stepDistance) - this.Engine.defaultStep) * 0.5 + row * Math.abs(this.Engine.stepDistance));
                    this._posContainer.addChild(tempSp);
                    this._currentPointMap.push(Helper_1.Helper.copyLocalPosition(cont, tempSp));
                }
                this._posContainer.removeChildren();
                return this._currentPointMap;
            // const symbol:IReelSpriteSymbol = PunkEngineManager.getReel(item.ReelID).getSymbol(item.SymID);
            // item.itemContainer.position = PunkHelper.copyLocalPosition(item.itemContainer,symbol);
            /*
            *  TODO: Create a map that can preCalculate the positions if we get Stacked Symbols.
            */
            // case ReelState.STOP:
            // case ReelState.STOP_TEASER:
            //     for(var row = -this.overflowDirection; row < this.windowAmount+this.overflowTail; row++){
            //         // ... 
            //     }
            //     break;
            default:
                Logger_1.Logger.warn("Seems like you are using an undefined ReelState.");
                break;
        }
        return [];
    }
    onStep() {
        this.AllSymbols.forEach(sym => {
            this.Engine.reverse ? sym.posID-- : sym.posID++;
            sym.y += this.Engine.stepDistance;
            sym.y = Math.round(sym.y);
        });
        let checkReverse = this.Engine.reverse;
        while (this.tryRemoveSymbol(checkReverse))
            ;
        while (this.tryAddNextSymbol(checkReverse))
            ;
        if (this.state.willUpdateStep && this.Engine.nextTimeline)
            this.updatingStep();
        else if (this.state.willStop && this.Engine.nextTimeline)
            this.activateStop();
    }
    updateStep() {
        this.state.set(ReelState.STEP, true);
        while (!this.Engine.nextTimeline)
            this.Engine.Step();
    }
    updatingStep() {
        this.state.set(ReelState.IDLE, true);
        this.Engine.activateNextAnimation();
    }
    activateStop() {
        this.state.set(this.state.subState);
        this.state.set(ReelState.IDLE, true);
        const stepOffset = 1;
        this.Engine.Steps -= ((this.totalOverflow - this.engineConfig.RESULT_OVERFLOW) - stepOffset);
        this.Engine.activateNextAnimation();
    }
    checkSymbolBoundries(symbolToCheck, inside, reverse) {
        let posY = symbolToCheck.position.y + ((reverse ? 1 : -1) * (symbolToCheck.symbolHeight));
        const engineStep = Math.abs(this.Engine.stepDistance);
        const stepDistanceOffset = this.Engine.defaultStep - engineStep;
        const fromDirection = stepDistanceOffset + (engineStep) * this.overflowDirection;
        const toDirection = -stepDistanceOffset + (this.maxHeight - engineStep) + (engineStep * this.overflowTail);
        // Check if it is visible by Restriction and symbol size.
        let fromTop = false;
        let fromBott = false;
        if (inside) {
            fromTop = (!reverse && posY >= -fromDirection);
            fromBott = (reverse && posY <= toDirection);
        }
        else {
            fromTop = (reverse && posY <= -fromDirection);
            fromBott = (!reverse && posY >= toDirection);
            if (fromTop || fromBott)
                (fromTop ? this.AllSymbols.shift() : this.AllSymbols.pop()).remove();
        }
        return fromTop || fromBott;
    }
    tryAddNextSymbol(reverse) {
        const symbolToCheck = reverse ? this.bottomSymbol : this.topSymbol;
        const willSpawn = this.checkSymbolBoundries(symbolToCheck, true, reverse);
        let posY = symbolToCheck.position.y + ((reverse ? 1 : -1) * (symbolToCheck.symbolHeight));
        // Check if it is visible by Restriction and symbol size.
        const nextSymName = this.findNextSymbol();
        if (willSpawn) {
            const posID = symbolToCheck.posID + (reverse ? 1 : -1);
            let symState = ReelSpriteSymbolArea_1.ReelSymbolStates.NORMAL;
            if (this.state.isSpinning || this.state.isStarting || this.state.isStopping)
                symState = ReelSpriteSymbolArea_1.ReelSymbolStates.SPIN;
            const symbol = this.addingNextStepSymbol(posID, nextSymName, symState);
            // AddOffset if the symbols have a missmatch on sizes between them.
            const YOffsetFromOrigin = (symbol.symbolHeight - symbolToCheck.symbolHeight) * 0.5;
            posY += reverse ? YOffsetFromOrigin : -YOffsetFromOrigin;
            symbol.position.y = posY - this.engineConfig.STEP_DISTANCE_PADDING_Y;
            this.addSymbol(symbol);
            this._nextSymbol = undefined;
            if (this.state.isStopping && this.Engine.Steps >= 0) {
                this.Engine.reverse ? this.Engine.Steps++ : this.Engine.Steps--;
            }
        }
        else if (!this._nextSymbol) {
            this._nextSymbol = nextSymName;
        }
        return willSpawn;
    }
    addingNextStepSymbol(_posID, _sym, _state) {
        return this.createNewSymbol(_posID, _sym, _state);
    }
    findNextSymbol() {
        const reelStopReelResult = this.state.equal(ReelState.QUICK_STOP) ? this._quickStopReelSet : this._stopReelSet;
        return this.state.isStopping && reelStopReelResult[this.Engine.Steps] != undefined ? reelStopReelResult[this.Engine.Steps] : this.generateNextSymbol(this._currentReelSet);
    }
    createStop() {
        if (this.state.isSpinning && !this.Engine.nextTimeline) {
            /* PunkRocker */
            //this.Engine.Steps = (this.showAmount - this.engineConfig.WINDOW_AMOUNT) + (this._stopReelSet.length - this.overflowDirection - (this.Engine.reverse ? 2 : 0));
            this.Engine.Steps = this.showAmount + this.overflowDirection + this.overflowTail;
            return this.createNextAnimation(ReelState.STOP);
        }
        return new gsap_1.TimelineLite();
    }
    stopSpin(playIdleStopReels) {
        if (this.state.isSpinning) {
            Logger_1.Logger.warn(`stop reel ${this.reelID} ${this._stopReelSet}`);
            if (this.isQuickStop)
                this.state.set(ReelState.QUICK_STOP, true);
            else
                this.state.set(GameSetting_1.GameSetting.isFastSpin ? ReelState.FAST_STOP : ReelState.STOP, true);
        }
        else if ((!this.isActive || playIdleStopReels) && this.state.equal(ReelState.IDLE) || this.state.equal(ReelState.INACTIVE)) {
            // If reel not active we fake a spin stopped
            Logger_1.Logger.warn(`ReelEngineController.stopSpin():Inactive reel ${this.reelID} stop spin animation completed!`);
            this.onStopAnimationCompleted();
        }
    }
    getPlayTime() {
        if (!this.Engine.isActive)
            return 0;
        return this.Engine.activeTimeline.duration() - this.Engine.activeTimeline.time();
    }
    getNextAnimationTime() {
        if (!this.Engine.nextTimeline)
            return 0;
        return this.Engine.nextTimeline.totalDuration();
    }
    onStopStarted() {
        const _duration = this.getStopDuration();
        const _ease = this.getStopEase();
        for (var i = 0; i < this.AllSymbols.length; i++) {
            this.AllSymbols[i].changeState({
                state: ReelSpriteSymbolArea_1.ReelSymbolStates.NORMAL,
                ease: _ease,
                duration: _duration,
            });
        }
        EventHandler_1.EventHandler.dispatchEvent(new GameEvent_1.GameEvent(ReelEngineEvent_1.ReelEngineEvent.REEL_STOP_SPIN_STARTED, this.reelID));
    }
    onStopAnimationCompleted() {
        this.setCurrentReelSet(this._nextReelSetName);
        this.createNextAnimation(ReelState.IDLE, true);
        if (this._activeReel)
            this.onStep();
        this.setVisibleForOverflowSymbols(false);
        if (this.Engine.nextTimeline)
            this.Engine.activateNextAnimation();
        this._activeReel = this._nextResultActive;
        EventHandler_1.EventHandler.dispatchEvent(new GameEvent_1.GameEvent(ReelEngineEvent_1.ReelEngineEvent.REEL_STOP_COMPLETED, this.reelID));
    }
    setVisibleForOverflowSymbols(value) {
        if (!this.isActive)
            return;
        for (let posID = -this.overflowDirection; posID < this._showAmount + this.overflowTail; posID++) {
            if (posID == 0)
                posID = this._showAmount;
            if (this.getSymbol(posID) !== undefined && (posID < 0 || posID >= this._showAmount))
                this.getSymbol(posID).visible = value;
        }
    }
    onBounceStarted() {
        EventHandler_1.EventHandler.dispatchEvent(new GameEvent_1.GameEvent(ReelEngineEvent_1.ReelEngineEvent.REEL_STOP_SPIN_BOUNCE_STARTED, this.reelID));
    }
    completedNudge() {
        this.createNextAnimation(ReelState.IDLE, true);
        this.onStep();
        this.setVisibleForOverflowSymbols(false);
        this.Engine.activateNextAnimation();
        if (this.Engine.Steps > 0)
            this.nudge(this.Engine.Steps);
        else
            EventHandler_1.EventHandler.dispatchEvent(new GameEvent_1.GameEvent(ReelEngineEvent_1.ReelEngineEvent.REEL_NUDGE_COMPLETED, this.reelID));
    }
    nudge(steps = 1) {
        this.Engine.Steps = steps;
        this.createNextAnimation(ReelState.NUDGE, true);
        this.Engine.activateNextAnimation();
        this.AllSymbols.forEach(sym => { sym.visible = true; });
    }
    completedExpanding() {
        return this.createNextAnimation(ReelState.IDLE, true);
    }
    /**
     * Used to set a new reel set during spin. But it does NOT change the next reelSet which will be used when a new spin start.
     * Example : EventHandler.dispatchEvent(new GameEvent(ReelEngineEvent.REEL_SET_CURRENT_REEL_SET, {reelSetName :
     * "BASE_REELSET_WILD", reelSetPosition: 10}));
     * If reelSetPosition is not given, use a random value.
     * @param data
     */
    setCurrentReelSet(name) {
        if (!!GameConfig_1.GameConfig.instance.REEL_SETS[name] && GameConfig_1.GameConfig.instance.REEL_SETS[name].length > 0) {
            this._currentReelSet = GameConfig_1.GameConfig.instance.REEL_SETS[name][this.reelID];
            return;
        }
        debugger;
        throw new Error(`Error: ReelEngineController.setCurrentReelSet(name: string): Reel ${name} does not contain any symbol!`);
    }
}
exports.ReelEngineController = ReelEngineController;
//# sourceMappingURL=ReelEngineController.js.map